import { render, staticRenderFns } from "./SvgWithZoomAndTransparentHighlight.vue?vue&type=template&id=9799c8b4&scoped=true"
import script from "./SvgWithZoomAndTransparentHighlight.vue?vue&type=script&lang=ts"
export * from "./SvgWithZoomAndTransparentHighlight.vue?vue&type=script&lang=ts"
import style0 from "./SvgWithZoomAndTransparentHighlight.vue?vue&type=style&index=0&id=9799c8b4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9799c8b4",
  null
  
)

export default component.exports